















import { defineComponent } from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';
import VaimoIconSVG from 'atoms/VaimoIconSVG.vue';

export default defineComponent({
  name: 'VaimoLogo',
  components: {
    SfLink,
    VaimoIconSVG
  },
  props: {
    isWhite: {
      type: Boolean,
      default: false
    }
  }
});
